import img1 from '/images/aim.svg';
import img2 from '/images/global-team.svg';
import img3 from '/images/team-connection.svg';
import img4 from '/images/thinking.svg';
import { TwContainer } from '~/lib/TwContainer';
import { Text, Title } from '@mantine/core';

const BenifitsOfUs = () => {
	return (
		<section className="bg-white">
			<TwContainer className="py-24 px-8 z-10">
				<Title className="text-4xl font-medium font-saira text-secondary md:text-center ">BENEFITS OF WORKING WITH US</Title>

				<div className={'grid md:grid-cols-2 gap-8 mt-16 mx-auto max-w-4xl'}>
					<div className={'max-w-md gap-2 grid'}>
						<img
							src={img1}
							className={'h-24'}
						/>
						<Title
							order={4}
							className="text-primary font-saira">
							Kick Start
						</Title>
						<Text className="font-saira text-base">
							Our teams can be ramped up quickly and managed autonomously to implement and execute agreed plans.
						</Text>
					</div>
					<div className={'max-w-md gap-2 grid'}>
						<img
							src={img2}
							className={'h-24'}
						/>
						<Title
							order={4}
							className="text-primary font-saira">
							Top Quality Engineers
						</Title>
						<Text className="font-saira text-base">
							Our hiring process is constantly active to ensure your access to the best IT professionals in the market.
						</Text>
					</div>
					<div className={'max-w-md gap-2 grid'}>
						<img
							src={img3}
							className={'h-24'}
						/>
						<Title
							order={4}
							className="text-primary font-saira">
							End to End Management
						</Title>
						<Text className="font-saira text-base">
							We are responsible for your project completion and team management from start to end, guaranteeing quality product output.
						</Text>
					</div>
					<div className={'max-w-md gap-2 grid'}>
						<img
							src={img4}
							className={'h-24'}
						/>
						<Title
							order={4}
							className="text-primary font-saira">
							Operational Efficiency
						</Title>
						<Text className="font-saira text-base">
							Our cost effective services help reduce your costs to remain competitive without compromising quality.
						</Text>
					</div>
				</div>
			</TwContainer>
		</section>
	);
};
export default BenifitsOfUs;
